import React from 'react';
import LexicalRichEditor from '../ui/LexicalRichEditorLazy';

/**
 * A task comment's body. A rich comment (card 7de79076) renders its
 * `bodyHtml` through the same editor, read-only — that is what decrypts and
 * shows its images (they are encrypted attachments, so plain HTML could not;
 * the image node decrypts on its own — no upload plugin is mounted here).
 * Every other comment is the plain `body`, exactly as before.
 */
export default function CommentBody({ comment }) {
  if (!comment.bodyHtml) return <div className="task-detail-comment-body">{comment.body}</div>;
  return (
    <div className="task-detail-comment-body task-detail-comment-body--rich">
      <LexicalRichEditor
        fallback={<div>{comment.body}</div>}
        value={comment.bodyHtml}
        onChange={() => {}}
        disabled
        blockHandles={false}
        slashCommands={false}
        placeholder=""
      />
    </div>
  );
}
